import { render, staticRenderFns } from "./Kegs.vue?vue&type=template&id=98852d9e&scoped=true&lang=html&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98852d9e",
  null
  
)

export default component.exports